import type { ReactNode } from 'react';

export interface TabViewPanelProps {
  header: string | React.JSX.Element;
  disabled?: boolean;
  panelStyles?: string;
  children: ReactNode;
}

export default function TabViewPanel({ panelStyles, children }: TabViewPanelProps) {
  return <div className={panelStyles}>{children}</div>;
}
